import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import './ProfilePage.css'
import Spinner from "../components/Spinner";

export default function UserProfile() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("profile");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const statusMap = {
    paid: "پرداخت شده",
    pending: "در انتظار پرداخت",
    failed: "ناموفق",
    canceled: "لغو شده",
    processing: "در حال پردازش",
  }
  const API_BASE = "https://api.goharesadaf.ir/api";
  const token = localStorage.getItem("token");

  const handlePay = async (orderId) => {
    try {
      const startRes = await fetch("https://api.goharesadaf.ir/api/payment/start", {
        method: "POST",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ order_id: orderId }),
      });

      if (!startRes.ok) {
        const err = await startRes.json().catch(()=>({}));
        alert(err.message || "Error starting payment.");
        return;
      }

      const { ref, start_url } = await startRes.json();

      // 3) auto-post the RefId to Mellat
      const form = document.createElement("form");
      form.method = "POST";
      form.action = start_url || "https://bpm.shaparak.ir/pgwchannel/startpay.mellat";
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "RefId";
      input.value = ref;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      console.error(err);
      alert(err.message || "خطا در ثبت سفارش یا پرداخت");
    }
  };
  
  function headers(extra = {}) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...extra,
    };
  }

    useEffect(() => {
    if (!token) {
      navigate("/auth");
    }
  }, [token, navigate]);

  function toastOk(msg) {
    setMessage(msg);
    setTimeout(() => setMessage(""), 2500);
  }
  function toastErr(msg) {
    setError(msg);
    setTimeout(() => setError(""), 3500);
  }

  useEffect(() => {
    (async () => {
      try {
          const res = await fetch("https://api.goharesadaf.ir/api/user", {
              headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
          });

          if (res.status === 401) {
            localStorage.removeItem("token");
            navigate("/auth");
            return;
          }

        if (!res.ok) throw new Error("در یافتن کاربر، ایرادی پیش آمده است!");
        setUser(await res.json());
      } catch (e) {
        setError(e.message);
      }
    })();
  }, []);


  // fetch orders & wishlist
  useEffect(() => {
    if (tab === "orders") {
      fetch(`${API_BASE}/user/orders`, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((r) => r.json())
        .then(setOrders)
        .catch((e) => toastErr("در بارگیری سفارشات، ایرادی پیش آمده است!"));
    }
    
  }, [tab]);

  async function handleProfileSave(e) {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/user`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(user),
      });
      if (!res.ok) throw new Error("در ذخیره‌سازی، ایرادی پیش آمده است!");
      setUser(await res.json());
      toastOk("حساب کاربری با موفقیت بروزرسانی شد!");
    } catch (e) {
      toastErr(e.message);
    }
  }

  async function handleAvatarUpload(file) {
    if (!file) return;
    const form = new FormData();
    form.append("avatar", file);
    try {
      const res = await fetch(`${API_BASE}/user/avatar`, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: form,
        credentials: "include",
      });
      if (!res.ok) throw new Error("بارگیری موفق نبود... لطفاً دوباره تلاش کنید!");
      const data = await res.json();
      setUser((u) => ({ ...u, avatar_url: data.avatar_url }));
      toastOk("تصویر پروفایل، بروزرسانی شد!");
    } catch (e) {
      toastErr(e.message);
    }
  }

  async function handleDelete(orderId) {
    if (!window.confirm("آیا مطمئن هستید که می‌خواهید این سفارش را حذف کنید؟")) return;
    try {
      const res = await fetch(`${API_BASE}/orders/${orderId}`, {
        method: "DELETE",
        headers: headers(),
      });
      if (!res.ok) throw new Error("امکان حذف این سفارش وجود ندارد!");
      // remove the order from state
      setOrders((prev) => prev.filter((o) => o.id !== orderId));
      toastOk("سفارش با موفقیت حذف شد!");
    } catch (e) {
      toastErr(e.message);
    }
  }

  if (!user) return <Spinner />;

  return (
    <div className="up-shell">
      <div className="up-header">
        <div
          className="up-avatar-wrap"
          onClick={() => fileInputRef.current?.click()}
        >
          <img
            src={
              user.avatar_url ||
              `https://ui-avatars.com/api/?name=${encodeURIComponent(
                user.name || "U"
              )}`
            }
            alt="Avatar"
            className="up-avatar"
          />
          <div className="up-avatar-edit">تغییر دادن عکس</div>
          <input
            ref={fileInputRef}
            type="file"
            hidden
            accept="image/*"
            onChange={(e) => handleAvatarUpload(e.target.files[0])}
          />
        </div>
        <div className="up-meta">
          <h1>{user.name}</h1>
          <p>{user.email}</p>
          <p>{user.phone}</p>

        </div>
      </div>

      <div className="up-tabs">
        <button onClick={() => setTab("profile")} className={tab === "profile" ? "active" : ""}>حساب کاربری</button>
        <button onClick={() => setTab("orders")} className={tab === "orders" ? "active" : ""}>سفارش‌ها</button>
        <button onClick={() => navigate("/wishlist")}>علاقه‌مندی‌ها</button>
      </div>

      {message && <div className="up-toast success">{message}</div>}
      {error && <div className="up-toast error">{error}</div>}

      {tab === "profile" && (
        <form className="up-card" onSubmit={handleProfileSave}>
          <label>
            <span>نام و نام خانوادگی</span>
            <input
              value={user.name || ""}
              onChange={(e) => setUser({ ...user, name: e.target.value })}
            />
          </label>
          <label>
            <span>شمارۀ تلفن</span>
            <input
              value={user.phone || ""}
              onChange={(e) => setUser({ ...user, phone: e.target.value })}
            />
          </label>
          <label>
            <span>آدرس پستی</span>
            <textarea
              value={user.address || ""}
              onChange={(e) =>
                setUser({ ...user, address: e.target.value })
              }
            />
          </label>

          <div className="up-actions">
            <button type="submit">ذخیره</button>
          </div>
        </form>
      )}

     {tab === "orders" && (
      <div className="up-card">
        {orders.length === 0 ? (
          <div>هیچ سفارشی موجود نیست!</div>
        ) : (
          <div className="up-orders">
            {orders.map((o) => (
              <div
                key={o.id}
                className="up-order clickable"
                onClick={() => navigate(`/orders/${o.id}`)}
              >
                <div className="up-order-row">
                  <span className="label">شماره سفارش</span>
                  <span>{o.id.toLocaleString("fa-IR")}</span>
                </div>
                <div className="up-order-row">
                  <span className="label">تاریخ ایجاد</span>
                  <span>{new Date(o.created_at).toLocaleDateString("fa-IR")}</span>
                </div>
                <div className="up-order-row">
                  <span className="label">وضعیت سفارش</span>
                  <span>{statusMap[o.status] || o.status}</span>
                </div>
                <div className="up-order-row">
                  <span className="label">مبلغ کل</span>
                  <span>{Number(o.total).toLocaleString("fa-IR")} تومان</span>
                </div>
                {o.status === "pending" && (
                  <div
                    className="up-order-actions"
                    onClick={(e) => e.stopPropagation()} // prevent navigation
                  >
                    <button className="btn-primary" onClick={() => handlePay(o.id)}>
                      پرداخت
                    </button>
                    <button className="btn-quiet" onClick={() => handleDelete(o.id)}>
                      حذف
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    )}



      

      
    </div>
  );
}
